import * as Tone from 'tone';
import { getNoteFromIndex, shuffleArray } from "@/functions";
export class AudioTrack {
    /**
     * Handles the audio operation of playing
     * a single sample with configurable settings
     * @param id - the id of the track
     * @param config - the configuration for the track
     */
    constructor({ id, config }) {
        this._sampleIndex = 0; // Not the same as ID
        this._id = id;
        this._config = config;
        console.log("AudioTrack", id, config);
        // There are 2 things to consider. Order, and follow action
        // Order is random or chain
        // Follow action is random or chain
        // Pick a random sample
        const { samplePool, randomOrder } = config;
        // Store the sample pool so we can change the sample later if required
        this._samplePool = randomOrder ? shuffleArray(samplePool) : samplePool;
        // Note that will trigger the sample
        this._note = getNoteFromIndex(this._id);
    }
    /**
     * Create the loop for this track
     * @param sampler
     */
    createLoop(sampler) {
        this._loop = new Tone.Loop((time) => this.playSample(time, sampler), this._config.length).start(0);
    }
    startLoop() {
        if (this._loop) {
            if (this._loop.state === "stopped") {
                this._loop.start(0);
            }
        }
    }
    stopLoop() {
        if (this._loop) {
            this._loop.stop(0);
        }
    }
    /**
     * Play the sample in the given sampler
     * @param sampler
     */
    playSample(time, sampler) {
        const { length, startRange, startOffset, velocity, followAction } = this._config;
        let randomStartDelay;
        let startTime = time;
        // In the case of a GroupPlayer, all the samples
        // are loaded... we just need to change the note
        // There is only one track, so move along to the next sample
        if (followAction === "chain") {
            // The notes just go up in semitones playing the next sample
            this._id = (this._id + 1) % this._samplePool.length;
            this._note = getNoteFromIndex(this._id);
        }
        if (startRange !== undefined) {
            // If startRange is of the form "2m", "4m", "8m", etc.
            if (/\dm|n/.test(startRange.toString())) {
                // Convert to seconds, randomise, quantize then convert back to notation (relative)
                const timeAsSeconds = Tone.Time(startRange).toSeconds();
                const randomStartDelay = Tone.Time(Math.random() * timeAsSeconds).quantize("8n");
                startTime = `+${Tone.Time(randomStartDelay).toNotation()}`;
            }
            else {
                randomStartDelay = Math.random() * Number(startRange);
                startTime = Number(time) + randomStartDelay;
            }
        }
        // Allows for relatively short samples to be
        // placed at non 1 1 1 1 points in the bar (eg. ogre triangle)
        if (startOffset !== undefined) {
            startTime = `+${startOffset}`;
        }
        console.log("playSample", time, this._note, startTime, this.src);
        if (sampler.loaded) {
            sampler.triggerAttackRelease(this._note, length, startTime, velocity);
        }
        else {
            console.log("Sampler is not ready");
        }
    }
    changeSampleIndex(indexRange, sampler) {
        // console.log("changeSampleIndex called", indexRange, "Current", this._id);
        // Release current?
        const randomIndex = Math.floor(Math.random() * indexRange.length);
        const newId = indexRange[randomIndex]; // Might just be one item in there
        // Update the ID & note now
        if (newId !== this._id) {
            this._id = newId;
            // Release current note
            if (sampler) {
                // console.log("Releasing", this._note);
                sampler.releaseAll();
            }
            this._note = getNoteFromIndex(this._id);
        }
    }
    selectRandomSample(sampler) {
        this._id = Math.floor(Math.random() * this._samplePool.length);
        this._note = getNoteFromIndex(this._id);
        // Release current note
        if (sampler) {
            sampler.releaseAll();
        }
    }
    get id() {
        return this._id;
    }
    get note() {
        return this._note;
    }
    get src() {
        return `${this._samplePool[this._sampleIndex]}.mp3`;
    }
    get srcPool() {
        return this._samplePool.map(sample => `${sample}.mp3`);
    }
    get loop() {
        return this._loop;
    }
}
